import {
  compareKeyMetricsEngagementRateTips,
  compareKeyMetricsEngagementTips,
} from '@op/components/BubbleCommon';
import { barIcon, lineIcon, pieIcon } from '@op/constants/chart';
import { arrayToObj } from '@op/utils';
export const nikkeTimelineTypeOptions = [
  {
    text: 'Mentions',
    value: 'mentions',
    operations: [lineIcon, barIcon, pieIcon],
    downloadText: 'Mentions',
  },
  {
    text: 'Positive%-2',
    value: 'positive_mentions',
    operations: [lineIcon, barIcon],
    downloadText: 'Positive Mentions',
  },
  {
    text: 'Negative%-2',
    value: 'negative_mentions',
    operations: [lineIcon, barIcon],
    downloadText: 'Negative Mentions',
  },
  { text: 'Sentiment', value: 'sentiment', operations: [lineIcon] },
  {
    text: 'Engagement',
    value: 'engagement',
    operations: [lineIcon, barIcon, pieIcon],
    tips: compareKeyMetricsEngagementTips,
  },
  {
    text: 'Engagement%',
    value: 'engagement_ratio',
    operations: [lineIcon, barIcon],
    tips: compareKeyMetricsEngagementRateTips,
  },
];

export const nikkeTimeLineTypeMap = arrayToObj(
  nikkeTimelineTypeOptions,
  'value',
);

export const summaryGptTitle = [
  {
    key: 'global_gpt_summary',
    keyEn: 'global_gpt_summary_en',
    'en-US': '✦ Global Opinion Summary',
    'zh-CN': '✦ 全球舆情总结',
    savePrefix: "Global",
    dealwithParams: (filter: any) => ({
      ...filter,
      language: [],
    }),
  },
  {
    key: 'ko_gpt_summary',
    keyEn: 'ko_gpt_summary_en',
    savePrefix: "Korean",
    'en-US': '✦ Korean Opinion Summary',
    'zh-CN': '✦ 韩语舆情总结',
    dealwithParams: (filter: any) => ({
      ...filter,
      language: ['ko'],
    }),
  },
  {
    key: 'ja_gpt_summary',
    keyEn: 'ja_gpt_summary_en',
    savePrefix: "Japanese",
    'en-US': '✦ Japanese Opinion Summary',
    'zh-CN': '✦ 日语舆情总结',
    dealwithParams: (filter: any) => ({
      ...filter,
      language: ['ja'],
    }),
  },
  {
    key: 'en_gpt_summary',
    keyEn: 'en_gpt_summary_en',
    savePrefix: "English",
    'en-US': '✦ English Opinion Summary',
    'zh-CN': '✦ 英语舆情总结',
    dealwithParams: (filter: any) => ({
      ...filter,
      language: ['en'],
    }),
  },
];
